import { Firebase } from '@linktivity/link-utils';
import { message } from '@linktivity/link-ui';
import i18n from '@triplabo/web/i18n';
import { auth } from '@triplabo/web/stores';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN
};

const tenantId = import.meta.env.VITE_APP_FIREBASE_TENANT_ID;

class FirebaseAuth extends Firebase {
  constructor() {
    super(firebaseConfig);
    this.setTenantId(tenantId);
    this.auth.onAuthStateChanged(user => {
      if (user) {
        auth.setWebUser(user);
      } else {
        auth.clearTokens();
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showErrorMessage(error: any) {
    const errorCode = error.code;
    let errorMessage = error.message;
    if (i18n.exists(`firebase.${errorCode}`)) {
      errorMessage = i18n.t(`firebase.${errorCode}`);
    }
    message.error(errorMessage);
  }
}

// const firebaseAuth = new FirebaseAuth();

export default FirebaseAuth;
